<ng-container
  *ngIf="(additionalInformation !== undefined && additionalInformation.LineTemplate != null && additionalInformation.LineTemplate !== '') && (!(screenSize === 'large' || screenSize === 'medium' || screenSize === 'x-large'))">
  <ng-container *ngIf="this.screenSize === 'small' || this.screenSize === 'x-small' || true">
    <ng-container *ngIf="visibleRows.length; else noData">
      <nz-row [nzGutter]="16">
        <nz-col *ngFor="let row of visibleRows" [nzXs]="24" [nzSm]="12" [nzMd]="8" [nzLg]="6" [nzXl]="4">
          <nz-card nzHoverable style="margin-bottom: 16px;">
            <ul style="list-style: none; padding: 0; margin: 0;">
              <li *ngFor="let col of visibleColumn"
                style="margin-bottom: 8px; display: flex; justify-content: space-between;">
                <span style="font-weight: 600;">{{ col.Title | locale }}</span>
                <span>
                  <ng-container [ngSwitch]="col.Type">

                    <!-- text / label -->
                    <app-cell-label *ngSwitchCase="1" [colData]="col" [value]="row.data[col.Name]"
                      [linkedModule]="col.LinkedModule" [linkedModuleField]="row.data[col.ModuleID]"
                      [keyName]="col.KeyName" [recordModel]="recordModel" [keyValue]="row.data[col.KeyName]"
                      [dataset]="dataset" [tableName]="tableName" [row]="row.index"
                      [cellSettings]="cellSettings"></app-cell-label>

                    <!-- numeric (same as label) -->
                    <app-cell-label *ngSwitchCase="16" [colData]="col" [value]="row.data[col.Name]"
                      [linkedModule]="col.LinkedModule" [linkedModuleField]="row.data[col.ModuleID]"
                      [keyName]="col.KeyName" [recordModel]="recordModel" [keyValue]="row.data[col.KeyName]"
                      [dataset]="dataset" [tableName]="tableName" [row]="row.index"
                      [cellSettings]="cellSettings"></app-cell-label>

                    <!-- date -->
                    <app-cell-date *ngSwitchCase="2" [colData]="col" [value]="row.data[col.Name]" [dataset]="dataset"
                      [tableName]="tableName" [row]="row.index" [cellSettings]="cellSettings"></app-cell-date>

                    <!-- amount -->
                    <app-cell-amount *ngSwitchCase="4" [colData]="col" [value]="row.data[col.Name]" [dataset]="dataset"
                      [tableName]="tableName" [row]="row.index" [cellSettings]="cellSettings"
                      [recordModel]="recordModel" [moduleStructure]="moduleStructure"></app-cell-amount>

                    <!-- simple checkbox -->
                    <app-cell-checkbox *ngSwitchCase="5" [colData]="col" [value]="row.data[col.Name]"
                      [dataset]="dataset" [tableName]="tableName" [row]="row.index" [cellSettings]="cellSettings"
                      [recordModel]="recordModel" [moduleStructure]="moduleStructure"></app-cell-checkbox>

                    <!-- select/dropdown -->
                    <app-cell-select *ngSwitchCase="7" [colData]="col" [value]="row.data[col.Name]"
                      [options]="col.Options" [dataset]="dataset" [tableName]="tableName" [row]="row.index"
                      [cellSettings]="cellSettings"></app-cell-select>

                    <!-- rich text / HTML -->
                    <app-cell-rich-text *ngSwitchCase="8" [colData]="col" [value]="row.data[col.Name]"
                      [dataset]="dataset" [tableName]="tableName" [row]="row.index" [cellSettings]="cellSettings"
                      [recordModel]="recordModel" [moduleStructure]="moduleStructure"></app-cell-rich-text>

                    <!-- quantity -->
                    <app-cell-quantity *ngSwitchCase="11" [colData]="col" [value]="row.data[col.Name]"
                      [dataset]="dataset" [tableName]="tableName" [row]="row.index"
                      [cellSettings]="cellSettings"></app-cell-quantity>

                    <!-- link -->
                    <app-cell-link *ngSwitchCase="12" [colData]="col" [value]="row.data[col.Name]"
                      [linkedModule]="col.LinkedModule" [linkedModuleField]="row.data[col.ModuleID]"
                      [keyName]="col.KeyName" [keyValue]="row.data[col.KeyName]" [dataset]="dataset"
                      [tableName]="tableName" [recordModel]="recordModel" [row]="row.index"
                      [cellSettings]="cellSettings"></app-cell-link>

                    <!-- selection checkbox -->
                    <app-cell-selection-checkbox *ngSwitchCase="14" [colData]="col" [value]="row.data[col.Name]"
                      [dataset]="dataset" [tableName]="tableName" [row]="row.index"
                      [cellSettings]="cellSettings"></app-cell-selection-checkbox>

                    <!-- icon -->
                    <app-cell-icon *ngSwitchCase="15" [colData]="col" [value]="row.data[col.Name]" [dataset]="dataset"
                      [tableName]="tableName" [row]="row.index" [cellSettings]="cellSettings"></app-cell-icon>

                    <!-- icon -->
                    <app-cell-images *ngSwitchCase="10" [colData]="col" [value]="row.data[col.Name]" [dataset]="dataset"
                      [tableName]="tableName" [row]="row.index" [cellSettings]="cellSettings"></app-cell-images>

                    <!-- fallback -->
                    <span *ngSwitchDefault>{{ row.data[col.Name] }}</span>
                  </ng-container>
                </span>
              </li>
            </ul>

            <ng-container *ngIf="actions.length">
              <div style="margin-top: 12px; text-align: right;">
                <a *ngFor="let action of actions; let i = index" [routerLink]="[
                action.Url,
                { id: row.data[action.IdColumn], additionalKey: row.data[action.AdditionalKeyCol] }
              ]">
                  {{ action.Text | locale }}<span *ngIf="i < actions.length - 1"> | </span>
                </a>
              </div>
            </ng-container>
          </nz-card>
        </nz-col>
      </nz-row>
    </ng-container>

    <ng-template #noData>
      <p style="text-align: center; color: #888; margin-top: 32px;">
        No records to display
      </p>
    </ng-template>

  </ng-container>
</ng-container>

<ng-container
  *ngIf="(additionalInformation === undefined || additionalInformation.LineTemplate == null || additionalInformation.LineTemplate === '') || !(!(screenSize === 'large' || screenSize === 'medium' || screenSize === 'x-large'))">
  <ng-container>
    <app-custom-buttons *ngIf="section != null" [moduleStructure]="moduleStructure" [recordModel]="recordModel"
      [recordPage]="this" [forSection]="true" [sectionId]="section.Id">
    </app-custom-buttons>
  </ng-container>

  <nz-table #tableOfDataRecs [nzData]="visibleRows" nzBordered nzShowQuickJumper="true" nzShowSizeChanger="true"
    nzSize="small" [nzFrontPagination]="
    section === undefined
      ? true && !serverSide
      : section.AdditionalInformationParsed.EnablePaging
  " nzHideOnSinglePage="false" [nzShowTotal]="rangeTemplate" [(nzPageSize)]="pageSize" [(nzPageIndex)]="pageIndex"
    (nzPageIndexChange)="pageIndexChanged.emit(this.pageIndex)" (nzPageSizeChange)="pageSizeChanged.emit(this.pageSize)"
    [nzTotal]="serverSide ? this.totalRecords : this.dataset.length" [nzLoading]="isTableLoading"
    [nzScroll]="{ x: '100px' }">
    <thead>
      <tr>
        <th *ngFor="let col of visibleColumn; let i = index" [nzLeft]="i == 0"
          [nzWidth]="col.Width == 0 ? '100px' : col.Width + 'px'" [nzSortFn]="!serverSide ? undefined : true"
          [nzSortDirections]="['ascend', 'descend']" [nzSortOrder]="
        !serverSide
                  ? undefined
                  : i + 1 === sortedByField
                  ? sortedByDir.toLowerCase() + 'end'
                  : ''
        " (nzSortOrderChange)="changeSorting(i + 1, $event)">
          <span *ngIf="col.Type !== 14">{{ col.Title | locale }}</span>
          <span *ngIf="col.Type === 14">
            <label nz-checkbox (nzCheckedChange)="colHeaderCheckChanged(col, $event)"></label>
          </span>
        </th>
        <th *ngIf="actions.length !== 0" [nzWidth]="'100px'">
          {{ "Actions" | locale }}
        </th>
      </tr>
      <tr class="filter-row" *ngIf="
        section === undefined
          ? displayFilter
          : section.AdditionalInformationParsed.EnableFilter
      ">
        <th *ngFor="let col of visibleColumn; let i = index" [nzLeft]="i == 0"
          [nzWidth]="col.Width == 0 ? '100px' : col.Width + 'px'">
          <ng-container *ngIf="col.Filterable" [ngSwitch]="col.Type">
            <nz-select *ngSwitchCase="7" [(ngModel)]="filters[col.Name].singleValue" nzAllowClear
              (ngModelChange)="updateFilter()">
              <ng-container *ngFor="let option of col.Options">
                <nz-option [nzValue]="option.Code.toString()" [nzLabel]="option.Name"></nz-option>
              </ng-container>
            </nz-select>
            <nz-select *ngSwitchCase="5" [(ngModel)]="filters[col.Name].singleValue" nzAllowClear
              (ngModelChange)="updateFilter()">
              <nz-option [nzLabel]="'Checked' | locale" [nzValue]="'true'">
              </nz-option>
              <nz-option [nzLabel]="'Not Checked' | locale" [nzValue]="'false'">
              </nz-option>
            </nz-select>
            <nz-select *ngSwitchCase="14" [(ngModel)]="filters[col.Name].singleValue" nzAllowClear
              (ngModelChange)="updateFilter()">
              <nz-option [nzLabel]="'Checked' | locale" [nzValue]="'true'">
              </nz-option>
              <nz-option [nzLabel]="'Not Checked' | locale" [nzValue]="'false'">
              </nz-option>
            </nz-select>
            <input *ngSwitchCase="1" nz-input [(ngModel)]="filters[col.Name].singleValue"
              (ngModelChange)="updateFilter()" />
            <div class="range-number" *ngSwitchCase="4">
              <nz-space nzDirection="vertical">
                <nz-space-item>
                  <nz-input-number [(ngModel)]="filters[col.Name].valueFrom" (ngModelChange)="updateFilter()"
                    [nzPlaceHolder]="'From' | locale"></nz-input-number>
                </nz-space-item>
                <nz-space-item>
                  <nz-input-number [(ngModel)]="filters[col.Name].valueTo" (ngModelChange)="updateFilter()"
                    [nzPlaceHolder]="'To' | locale"></nz-input-number>
                </nz-space-item>
              </nz-space>
            </div>
            <div class="range-number" *ngSwitchCase="16">
              <nz-space nzDirection="vertical">
                <nz-space-item>
                  <nz-input-number [(ngModel)]="filters[col.Name].valueFrom" (ngModelChange)="updateFilter()"
                    [nzPlaceHolder]="'From' | locale"></nz-input-number>
                </nz-space-item>
                <nz-space-item>
                  <nz-input-number [(ngModel)]="filters[col.Name].valueTo" (ngModelChange)="updateFilter()"
                    [nzPlaceHolder]="'To' | locale"></nz-input-number>
                </nz-space-item>
              </nz-space>
            </div>
            <div class="range-number" *ngSwitchCase="11">
              <nz-space nzDirection="vertical">
                <nz-space-item>
                  <nz-input-number [(ngModel)]="filters[col.Name].valueFrom" (ngModelChange)="updateFilter()"
                    [nzPlaceHolder]="'From' | locale"></nz-input-number>
                </nz-space-item>
                <nz-space-item>
                  <nz-input-number [(ngModel)]="filters[col.Name].valueTo" (ngModelChange)="updateFilter()"
                    [nzPlaceHolder]="'To' | locale"></nz-input-number>
                </nz-space-item>
              </nz-space>
            </div>
            <div *ngSwitchCase="12">
              <input nz-input [(ngModel)]="filters[col.Name].singleValue" (ngModelChange)="updateFilter()" />
            </div>
            <div class="range-date" *ngSwitchCase="2">
              <nz-space nzDirection="vertical">
                <nz-space-item>
                  <nz-date-picker [nzFormat]="global.companyConfiguration.DateFormat" [nzDateRender]="tplRender"
                    [(ngModel)]="filters[col.Name].valueFrom" (ngModelChange)="updateFilter()"
                    [nzPlaceHolder]="'From' | locale">
                  </nz-date-picker>
                </nz-space-item>
                <nz-space-item>
                  <nz-date-picker [nzFormat]="global.companyConfiguration.DateFormat" [nzDateRender]="tplRender"
                    [(ngModel)]="filters[col.Name].valueTo" (ngModelChange)="updateFilter()"
                    [nzPlaceHolder]="'To' | locale">
                  </nz-date-picker>
                </nz-space-item>
              </nz-space>
              <ng-template #tplRender let-current>
                <div class="ant-picker-cell-inner" [class.border]="current.getDate() === 1">
                  {{ current.getDate() }}
                </div>
              </ng-template>
            </div>
            <span *ngSwitchDefault></span>
          </ng-container>
        </th>
        <th *ngIf="actions.length !== 0"></th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let line of tableOfDataRecs.data"
        [class]="(line.data['SELECTED'] ? 'row-selected-' + tableName : '') + ' ' + line.data['ClassName']">
        <td *ngFor="let col of visibleColumn; let i = index" [nzLeft]="i == 0" [nzEllipsis]="true"
          style="white-space: normal">
          <app-cell-label *ngIf="(col.Type == 1 || col.Type == 16) && line.data !== undefined" [colData]="col"
            [value]="line.data[col.Name]" [linkedModule]="col.LinkedModule"
            [linkedModuleField]="line.data[col.ModuleID]" [keyName]="col.KeyName" [recordModel]="recordModel"
            [keyValue]="line.data[col.KeyName]" [dataset]="dataset" [tableName]="tableName" [row]="line.index"
            [cellSettings]="cellSettings">
          </app-cell-label>
          <app-cell-icon *ngIf="col.Type == 15 && line.data !== undefined" [colData]="col" [value]="line.data[col.Name]"
            [dataset]="dataset" [tableName]="tableName" [row]="line.index" [cellSettings]="cellSettings">
          </app-cell-icon>

          <app-cell-images *ngIf="col.Type == 10 && line.data !== undefined" [colData]="col"
            [value]="line.data[col.Name]" [dataset]="dataset" [tableName]="tableName" [row]="line.index"
            [cellSettings]="cellSettings"></app-cell-images>

          <app-cell-date *ngIf="col.Type == 2 && line.data !== undefined" [colData]="col" [value]="line.data[col.Name]"
            [dataset]="dataset" [tableName]="tableName" [row]="line.index" [cellSettings]="cellSettings">
          </app-cell-date>
          <app-cell-amount *ngIf="col.Type == 4 && line.data !== undefined" [colData]="col"
            [value]="line.data[col.Name]" [dataset]="dataset" [tableName]="tableName" [row]="line.index"
            [cellSettings]="cellSettings" [recordModel]="recordModel" [moduleStructure]="moduleStructure">
          </app-cell-amount>
          <app-cell-rich-text *ngIf="col.Type == 8 && line.data !== undefined" [colData]="col"
            [value]="line.data[col.Name]" [dataset]="dataset" [tableName]="tableName" [row]="line.index"
            [cellSettings]="cellSettings" [recordModel]="recordModel" [moduleStructure]="moduleStructure">
          </app-cell-rich-text>
          <app-cell-checkbox *ngIf="col.Type == 5 && line.data !== undefined" [colData]="col"
            [value]="line.data[col.Name]" [dataset]="dataset" [tableName]="tableName" [row]="line.index"
            [cellSettings]="cellSettings" [recordModel]="recordModel" [moduleStructure]="moduleStructure">
          </app-cell-checkbox>
          <app-cell-selection-checkbox *ngIf="col.Type == 14 && line.data !== undefined" [colData]="col"
            [value]="line.data[col.Name]" [dataset]="dataset" [tableName]="tableName" [row]="line.index"
            [cellSettings]="cellSettings">
          </app-cell-selection-checkbox>
          <app-cell-select *ngIf="col.Type == 7 && line.data !== undefined" [colData]="col"
            [value]="line.data[col.Name]" [dataset]="dataset" [tableName]="tableName" [row]="line.index"
            [options]="col.Options" [cellSettings]="cellSettings">
          </app-cell-select>
          <app-cell-quantity *ngIf="col.Type == 11 && line.data !== undefined" [colData]="col"
            [value]="line.data[col.Name]" [dataset]="dataset" [tableName]="tableName" [row]="line.index"
            [cellSettings]="cellSettings">
          </app-cell-quantity>
          <app-cell-link *ngIf="
            col.Type == 12 &&
            line.data !== undefined &&
            line.data[col.Name] != null
          " [colData]="col" [value]="line.data[col.Name]" [linkedModule]="col.LinkedModule"
            [linkedModuleField]="line.data[col.ModuleID]" [keyName]="col.KeyName" [keyValue]="line.data[col.KeyName]"
            [dataset]="dataset" [tableName]="tableName" [recordModel]="recordModel" [row]="line.index"
            [cellSettings]="cellSettings">
          </app-cell-link>
        </td>
        <td *ngIf="actions.length !== 0">
          <a *ngFor="let action of actions; let i = index" [routerLink]="[
            action.Url,
            {
              id: line.data[action.IdColumn],
              additionalKey: line.data[action.AdditionalKeyCol]
            }
          ]">
            {{ action.Text | locale }}
            <span *ngIf="i != actions.length - 1"> 一 </span>
          </a>
        </td>
      </tr>
    </tbody>
    <tfoot *ngIf="displayFooter">
      <tr>
        <td *ngFor="let col of visibleColumn; let i = index" [nzLeft]="i == 0">
          <span class="footer-title" *ngIf="i === 0">
            {{ "&Sigma;" | locale }}
          </span>
          <span *ngIf="col.FooterResult !== undefined">
            {{ col.FooterResult | number }}
          </span>
        </td>
      </tr>
    </tfoot>

    <ng-template #rangeTemplate let-range="range" let-total>
      {{ range[0] }}-{{ range[1] }} of {{ total }} items
    </ng-template>
  </nz-table>
</ng-container>
